// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__djvYE","content":"styles_content__1fxIr"};